import { connect } from 'react-redux';
import BuySellInstrumentSelector from './BuySellInstrumentSelector';
import {
  instrumentsWithProductFullNamesAndProductSymbols,
  selectedInstrumentSelector,
} from '@alphapoint/apex-web/lib/redux/selectors/instrumentPositionSelectors';
import { onInstrumentSelect } from '@alphapoint/apex-web/lib/redux/actions/buySellActions';
import { isBuySideBuySellFormSelector } from '@alphapoint/apex-web/lib/redux/selectors/buySellSelectors';
import { isMarginActiveSelector } from '@alphapoint/apex-web/lib/redux/margin/selectors';
import config from '@alphapoint/apex-web/lib/config';
import uniqBy from 'lodash/uniqBy';
import { change } from 'redux-form';
import { clearBuySellForm } from '@alphapoint/apex-web/lib/redux/actions/orderEntryActions';
import { buyValue, sellValue } from '@alphapoint/apex-web/lib/constants/sendOrder/orderEntryFormConstants';

const mapStateToProps = (state) => {
  const { dealPrices } = config.RetailBuySell;

  const isBuySide = isBuySideBuySellFormSelector(state);
  // t('Choose a Crypto to Buy');
  // t('Choose a Crypto to Sell');
  const buyLabel = 'Choose a Crypto to Buy';
  const sellLabel = 'Choose a Crypto to Sell';

  let instruments = instrumentsWithProductFullNamesAndProductSymbols(state);

  const isMarginActive = isMarginActiveSelector(state);
  if (!isMarginActive) {
    // eslint-disable-next-line no-prototype-builtins
    const filteredInstruments = instruments.filter((instrument) => dealPrices.hasOwnProperty(instrument.Symbol));

    if (filteredInstruments.length) instruments = filteredInstruments;
  }

  const product2Options = uniqBy(
    instruments.map((instrument) => ({
      value: instrument.Product2,
      label: instrument.Product2FullName,
    })),
    'value',
  );

  return {
    instruments,
    selectedInstrument: selectedInstrumentSelector(state),
    buyLabel,
    sellLabel,
    product2Options,
    isBuySide,
  };
};

const mapDispatchToProps = {
  onInstrumentSelect,
  setBuySide: () => change('buySell', 'side', buyValue),
  setSellSide: () => change('buySell', 'side', sellValue),
  clearForm: clearBuySellForm,
};

export default connect(mapStateToProps, mapDispatchToProps)(BuySellInstrumentSelector);
